import { useReducer } from 'react';
import { BaseWindowShade } from './BaseWindowShade';
import { jsx as _jsx } from "react/jsx-runtime";
export const WindowShade = ({
  initialOpenSections,
  isAccordion,
  staticMode,
  ...props
}) => {
  const [openSections, toggleSection] = useReducer((prevState, sectionIndex) => {
    const prevIndex = prevState.indexOf(sectionIndex);
    if (prevIndex === -1) {
      return isAccordion ? [sectionIndex] : [...prevState, sectionIndex];
    } else {
      const nextState = prevState.slice();
      nextState.splice(prevIndex, 1);
      return nextState;
    }
  }, initialOpenSections || []);
  const onToggleSection = sectionIndex => {
    if (!props.sections[sectionIndex].staticMode) {
      toggleSection(sectionIndex);
      props.onToggleSection?.(sectionIndex);
    }
  };
  return /*#__PURE__*/_jsx(BaseWindowShade, {
    staticMode: staticMode,
    ...props,
    openSections: props.openSections ?? openSections,
    onToggleSection: onToggleSection
  });
};
export function getUpdatedOpenSectionsOnToggle(openSections, toggledIndex, isAccordion = false) {
  if (isAccordion) {
    return [toggledIndex];
  }
  const updatedOpenSections = [...openSections];
  const targetIndex = openSections.indexOf(toggledIndex);
  if (targetIndex !== -1) {
    updatedOpenSections.splice(targetIndex, 1);
  } else {
    updatedOpenSections.push(toggledIndex);
  }
  return updatedOpenSections;
}
export function getUpdatedSectionsStateOnReorder(sections, openSections, oldIndex, newIndex) {
  const openSectionRefs = openSections.map(sectionIndex => sections[sectionIndex]);
  const reorderedSections = [...sections];
  const removedSections = reorderedSections.splice(oldIndex, 1);
  reorderedSections.splice(newIndex, 0, removedSections[0]);
  const reorderedOpenSections = openSectionRefs.map(sectionRef => reorderedSections.indexOf(sectionRef));
  return {
    sections: reorderedSections,
    openSections: reorderedOpenSections
  };
}
//# sourceMappingURL=WindowShade.js.map